import { userService } from '../../helpers/authservice/user.service';
import axiosIns from "@/helpers/axios";

const userdata = JSON.parse(localStorage.getItem('userdata'));

export const state = {
    currentUser: userdata ? userdata : null,
    getToken: null,
    loading: false,
    cachedata: false,
    balance: 0,
    settings: {
        anten: false,
        winbox: false,
        domain_update: false,
        antedomainsn: [],
    }
}



export const getters = {
    userdata(state) {
        return state
    },
    getToken(state) {
        return state;
    },
    loading(state) {
        return state
    },
    settings(state) {
        return state.settings;
    },
    balance(state) {
        return state.balance;
    }
}

export const actions = {
    loadingStatus({ commit }, status) {
        commit('loginLoading',status);
    },
    login({ dispatch, commit }, { email, password }) {
        userService.login(email, password)
            .then(
                user => {
                    if (user.data.token) {
                        userService.me(user.data.token)
                            .then(user => {
                                localStorage.setItem('userdata', JSON.stringify(user.data))
                                commit('loginSuccess', user.data);
                                dispatch('notification/success', 'Giriş Başarılı', { root: true });
                                commit('loginLoading', false);
                                location.href="/"
                            })
                    } else {
                        commit('loginLoading',false);
                        commit('loginFailure', user.data.cause);
                        dispatch('notification/error', user.data.cause, { root: true });
                    }
                },
                error => {
                    commit('loginLoading',false);
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },
    forgotPassword({ dispatch,commit }, email) {
        const requestOptions = { email };
        return axiosIns.post(`forgotPassword`, requestOptions)
            .then((error) => {
                if (error.data.error) {
                    commit('loginLoading',false);
                    dispatch('notification/error', error.data.cause, { root: true });
                } else {
                    commit('loginLoading',false);
                    dispatch('notification/success', error.data.content, { root: true })    
                }
            });
    },
    logout({ commit }) {
        userService.logout();
        commit('logout');
    },
    async fetchSettingsIfNeeded({ state,  commit }) {
        
        if (!state.cachedata) { 
            const settings = await axiosIns.get('/settings/main');
            commit('setSettings', settings.data); 
            commit('setCachedata');
        }
    },
    async fetchBalance({ commit }) {
        const balance = await axiosIns.get('/dealers/get-balance');
        commit('setBalanceData', balance.data.balance); 
    },
};

export const mutations = { 
    setCachedata(state) {
        state.cachedata = true;
    },
    setBalanceData(state, balance) {
        state.balance = balance;
    },
    loginRequest(state, user) {
        state.user = user;
    },
    loginSuccess(state, user) {
        state.userdata = user;
        state.getToken = 123;
    },
    loginFailure(state) {
        state.user = null;
    },
    loginLoading(state, data) {
        state.loading = data;
    },
    logout(state) {
        state.user = null;
    },
    setSettings(state, settings) {
        state.settings = settings;
    }
};

